var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-link',{staticClass:"logo-link",attrs:{"to":{ name: 'home' }}},[(_vm.logo)?_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}}):_vm._e(),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('el-badge',{staticClass:"badge",attrs:{"value":"beta","type":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }